import { NOT_APPLICABLE } from "@DataPages/constants/cit.ts";
import { ICitActivity } from "@Common/types/ContractsInTransit/model";

export const isParentActivity = (activity: ICitActivity, hierarchyKey = "") =>
	Boolean((activity?.[hierarchyKey as keyof ICitActivity] as string[])?.length === 1);

export const getFundedStatus = (activity: ICitActivity, hierarchyKey = "") => {
	const { funded } = activity ?? {};
	const isParent = isParentActivity(activity, hierarchyKey);
	if (!isParent || funded === undefined) {
		return NOT_APPLICABLE;
	}
	return funded ? "Funded" : "Unfunded";
};
